import React from 'react'

const PaginaNo = () => {
  return (
    <div><h1>Pagina No Existe</h1></div>
  )
}

export default PaginaNo